// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1cv5ng10 {
  border-top: 1px solid var(--_18w76bw2a);
  font-size: var(--_18w76bw3r);
  color: #9b9b9b;
  font-weight: var(--_18w76bw40);
  padding-top: var(--_18w76bwg);
}
._1cv5ng11 {
  width: 100%;
}
@media screen and (min-width: 768px) {
  ._1cv5ng10 {
    border-top: 0;
    padding-top: 0;
  }
}
@media screen and (min-width: 1024px) {
  ._1cv5ng10 {
    font-size: 18px;
  }
  ._1cv5ng11 {
    width: calc(50% - 10px);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,4BAA4B;EAC5B,cAAc;EACd,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["._1cv5ng10 {\n  border-top: 1px solid var(--_18w76bw2a);\n  font-size: var(--_18w76bw3r);\n  color: #9b9b9b;\n  font-weight: var(--_18w76bw40);\n  padding-top: var(--_18w76bwg);\n}\n._1cv5ng11 {\n  width: 100%;\n}\n@media screen and (min-width: 768px) {\n  ._1cv5ng10 {\n    border-top: 0;\n    padding-top: 0;\n  }\n}\n@media screen and (min-width: 1024px) {\n  ._1cv5ng10 {\n    font-size: 18px;\n  }\n  ._1cv5ng11 {\n    width: calc(50% - 10px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
